import { AnimatePresence, motion } from "framer-motion";
import { Home, MessageSquare, FileText, ChartAreaIcon, Shield, User, Clock, Settings, X } from "lucide-react";
import React, { useState } from "react";

const MyProfileSidebarComponent = () => {
    const [modalContent, setModalContent] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [profileData, setProfileData] = useState({
        personal: {
            name: "John Anderson",
            title: "Senior Full Stack Developer",
            email: "john@example.com",
            phone: "+1 234 567 8900",
            timezone: "UTC-5",
            photo: "https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg",
            hourlyRate: 85,
            location: "Toronto, Canada",
            bio: "Full stack developer with 8+ years of experience specializing in React, Node.js, and cloud architecture.",
            availability: {
                regularHours: {
                    monday: { start: "09:00", end: "17:00", active: true },
                    tuesday: { start: "09:00", end: "17:00", active: true },
                    wednesday: { start: "09:00", end: "17:00", active: true },
                    thursday: { start: "09:00", end: "17:00", active: true },
                    friday: { start: "09:00", end: "17:00", active: true },
                    saturday: { start: "", end: "", active: false },
                    sunday: { start: "", end: "", active: false }
                },
                emergencyHours: {
                    monday: { start: "00:00", end: "23:59", active: true },
                    tuesday: { start: "00:00", end: "23:59", active: true },
                    wednesday: { start: "00:00", end: "23:59", active: true },
                    thursday: { start: "00:00", end: "23:59", active: true },
                    friday: { start: "00:00", end: "23:59", active: true },
                    saturday: { start: "00:00", end: "23:59", active: true },
                    sunday: { start: "00:00", end: "23:59", active: true }
                }
            },
            languages: ["English (Native)", "French (Professional)", "Spanish (Conversational)"],
            joined: "January 2023",
            lastActive: "2 hours ago",
            verified: true,
            rating: 4.9,
            completedProjects: 156,
            totalEarned: "125K+",
            successRate: 98
        },
    });
    const handleAvailabilityEdit = () => {
        setModalForm({ ...modalForm, availability: { ...profileData.personal.availability } });
        setModalContent("availability");
        setShowEditModal(true);
    };
    const sidebarItems = [
        { icon: <Home className="h-5 w-5" />, label: "Dashboard", href: "/professionals" },
        { icon: <MessageSquare className="h-5 w-5" />, label: "Messages", href: "/MessageAndVideoCall" },
        { icon: <FileText className="h-5 w-5" />, label: "My Orders", href: "/myorders" },
        { icon: <ChartAreaIcon className="h-5 w-5" />, label: "Progress", href: "/Progress" },
        { icon: <Shield className="h-5 w-5" />, label: "Support Tickets", href: "/support" },
        { icon: <User className="h-5 w-5" />, label: "My Profile", href: "/professionals/myprofile", active: true },
        { icon: <Clock className="h-5 w-5" />, label: "Availability", onClick: handleAvailabilityEdit },
        { icon: <Settings className="h-5 w-5" />, label: "Settings", href: "/professionals/settings" }

    ];


    const [modalForm, setModalForm] = useState({
        availability: {}
    });
    return (
        <>
            <aside className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-white border-r shadow-sm overflow-y-auto">
                <nav className="p-4 space-y-1">
                    {sidebarItems.map((item, index) => (
                        <button
                            key={index}
                            onClick={item.onClick || (() => window.location.href = item.href)}
                            className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors w-full text-left ${item.active
                                ? "text-blue-600 bg-blue-50 font-medium"
                                : "text-gray-600 hover:bg-gray-50"
                                }`}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>
            </aside>

            {/* Mobile Sidebar */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
                        />
                        <motion.aside
                            initial={{ x: "-100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "-100%" }}
                            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
                            className="fixed inset-y-0 left-0 w-full max-w-xs bg-white shadow-xl z-50 lg:hidden overflow-y-auto"
                        >
                            <div className="p-4">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-3">
                                        <img src="https://assests.netlify.app/assets/images/logo.png" alt="Logo" className="h-8 w-8" />
                                        <span className="text-blue-600 text-lg font-bold">Kokobeo</span>
                                    </div>
                                    <button
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                                    >
                                        <X className="h-6 w-6" />
                                    </button>
                                </div>
                                <nav className="space-y-1">
                                    {sidebarItems.map((item, index) => (
                                        <button
                                            key={index}
                                            onClick={() => {
                                                if (item.onClick) item.onClick();
                                                else window.location.href = item.href;
                                                setIsMobileMenuOpen(false);
                                            }}
                                            className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors w-full text-left ${item.active
                                                ? "text-blue-600 bg-blue-50 font-medium"
                                                : "text-gray-600 hover:bg-gray-50"
                                                }`}
                                        >
                                            {item.icon}
                                            <span>{item.label}</span>
                                        </button>
                                    ))}
                                </nav>
                            </div>
                        </motion.aside>
                    </>
                )}
            </AnimatePresence>
        </>
    );
};

export default MyProfileSidebarComponent;